<script>
export default {
  name: 'EmployeeSetting',
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      selectTypes: [],
      categoryList: []
    }
  },
  mounted() {
    this.getCategoryList()
    this.getDetails()
  },
  methods: {
    getCategoryList() {
      this.categoryList = []
      this.getHttpServices().getUserService().post('api/v2/merchant/product/category/list', {})
        .then(res => {
          this.categoryList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      console.error(this.selectTypes)
      const url = '/member/v3/authDetailInfo/saveAuthDetailInfo'
      this.getHttpServices().getMemberAuthService().post(url, {
        content: this.selectTypes.join(',')
      }).then((res) => {
        this.$message.success('保存成功')
      })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getDetails() {
      const merchantId = this.$store.getters.userInfo.merchantId
      const url = `/member/v3/authDetailInfo/getAuthDetailInfo/${merchantId}`
      this.getHttpServices().getMemberAuthService().post(url).then((res) => {
        if(res.content && res.content.length > 0) {
          this.selectTypes=res.content.split(',')
          console.error('this.selectTypes',this.selectTypes)
        }else{
          this.selectTypes=[]
        }
        console.error(res.content)
      })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<template>
  <a-card :card="false">
    <div slot="title" class="title-box">
      <span class="title">产品问控制</span>
      <span class="tips">说明：选中品类只有绑定企业才能访问详情页面</span>
    </div>
    <div class="employee-setting">
      <a-form-model
        :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-form-model-item label="访问控制类型">
          <a-checkbox-group v-model:value="selectTypes">
            <a-checkbox v-for="item in categoryList" :key="item.code" :value="item.code+''">{{ item.name }}</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false">
          <a-button type="primary" @click="handleSubmit">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-card>
</template>

<style scoped lang="less">
.title-box {
  width: 100%;
  display: flex;
  align-items: center;

  .title {
    font-size: 20px;
  }

  .tips {
    margin-left: 20px;
    font-size: 16px;
    color: #8F8F8F;
  }
}

.employee-setting {
  height: 400px;
  width: 100%;
}
</style>